import Papa from 'papaparse';

export const parseCSV = (csvString: string): Record<string, string>[] => {
  const parsedCsv = Papa.parse(csvString, {
    header: true,
  });

  if (parsedCsv.errors.length) {
    throw new Error('Error parsing CSV');
  } else {
    return parsedCsv.data;
  }
};
export const convertToCSV = (arr: unknown[]): string =>
  Papa.unparse(arr, {
    header: true,
  });
